import React from 'react';
import { SaveIcon } from 'lucide-react';
import { useSearchParams } from 'react-router-dom';
import BackButton from '../../../components/UI/BackButton';
import type { PM } from './useProductManager';
import { useDarkClasses } from '../../../hooks/useDarkClasses';
// Map returnTo paths to human-readable labels
const returnToLabels: Record<string, string> = {
  '/promotions': 'Promotions',
  '/vendors/dashboard': 'Dashboard',
  '/vendors/manage-listings': 'Manage Listings',
  '/vendors/marketing': 'Marketing Tools',
  '/vendors/pre-orders': 'Pre-Orders',
  '/vendors/arcs': 'ARC Management'
};
interface FormHeaderProps {
  pm: PM;
}
export const FormHeader: React.FC<FormHeaderProps> = ({
  pm
}) => {
  const dk = useDarkClasses();
  const [searchParams] = useSearchParams();
  const returnTo = searchParams.get('returnTo');
  const returnLabel = returnTo ? returnToLabels[returnTo] ?? 'Back' : undefined;
  const {
    productType,
    mode,
    showConfirmation,
    savedAsDraft,
    isProcessing,
    bookForm,
    merchForm,
    eventForm,
    bookBoxForm,
    creativeForm,
    serviceForm,
    setShowConfirmation,
    setProductType,
    handleSaveDraftClick,
    handlePublishClick
  } = pm;
  const editingTitle = productType === 'book' ? bookForm.title : productType === 'merch' ? merchForm.name : productType === 'bookbox' ? bookBoxForm.boxName : productType === 'creative' ? creativeForm.displayName : productType === 'service' ? serviceForm.displayName : eventForm.title;
  const typeLabel = productType === 'bookbox' ? 'Book Box' : productType === 'creative' ? 'Creative Profile' : productType === 'service' ? 'Service Provider' : productType!.charAt(0).toUpperCase() + productType!.slice(1);
  const accentClass = productType === 'book' ? 'bg-purple-600 hover:bg-purple-700' : productType === 'merch' ? 'bg-amber-500 hover:bg-amber-600' : productType === 'event' ? 'bg-teal-500 hover:bg-teal-600' : productType === 'bookbox' ? 'bg-pink-600 hover:bg-pink-700' : productType === 'creative' ? 'bg-violet-500 hover:bg-violet-600' : 'bg-blue-500 hover:bg-blue-600';
  return <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-6 sm:mb-8" data-id="element-20465" data-mp="1pazciaxvyl89">
      <div className="flex items-center" data-id="element-20466" data-mp="1t96wdennc2no">
        <div className="mr-3 sm:mr-4" data-id="element-20467" data-mp="1y9ujvqco21d5">
          <BackButton label={returnLabel ? `Back to ${returnLabel}` : 'Back'} to={showConfirmation ? undefined : returnTo ?? undefined} onClick={showConfirmation ? () => setShowConfirmation(false) : returnTo ? undefined : () => setProductType(null)} data-id="element-20468" data-mp="1y8rwvtigsj2i" />
        </div>
        <div data-id="element-20469" data-mp="2h13uk2y6aw6b">
          <h1 className={`text-xl sm:text-2xl font-bold ${dk.textHeading}`} data-id="element-20470" data-mp="2gyhpc9yr8sr9">
            {showConfirmation ? savedAsDraft ? 'Draft Saved' : 'Published' : mode === 'create' ? 'Create New' : 'Edit'}{' '}
            {!showConfirmation && typeLabel}
          </h1>
          <p className={`text-xs sm:text-sm ${dk.textMuted}`} data-id="element-20471" data-mp="3nk59lu8qlike">
            {showConfirmation ? `Your ${productType === 'bookbox' ? 'book box' : productType} has been successfully ${savedAsDraft ? 'saved as a draft' : 'published'}.` : mode === 'create' ? 'Fill in the details below' : `Editing: ${editingTitle}`}
          </p>
        </div>
      </div>
      {!showConfirmation && <div className="flex space-x-2 sm:space-x-3" data-id="element-20472" data-mp="aaha6e6mjw5b">
          <button onClick={handleSaveDraftClick} disabled={isProcessing} className={`px-3 sm:px-4 py-2 text-sm border rounded-md transition-colors ${dk.card} ${isProcessing ? 'opacity-50 cursor-not-allowed' : ''}`} data-id="element-20473" data-mp="17t0w5jz0umhq">
            {isProcessing && savedAsDraft ? 'Saving...' : 'Save Draft'}
          </button>
          <button onClick={handlePublishClick} disabled={isProcessing} className={`flex items-center px-3 sm:px-4 py-2 text-sm text-white rounded-md transition-colors ${accentClass} ${isProcessing ? 'opacity-50 cursor-not-allowed' : ''}`} data-id="element-20474" data-mp="dl1savk31aps">
            {isProcessing && !savedAsDraft ? <span className="flex items-center" data-id="element-20475" data-mp="1b93lpuus3fbi">
                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2" data-id="element-20476" data-mp="1ban01fwvjgan"></div>
                Publishing...
              </span> : <>
                <SaveIcon className="h-4 w-4 mr-1 sm:mr-2" data-id="element-20477" data-mp="11gxrsfkyunto" />
                <span className="hidden sm:inline" data-id="element-20478" data-mp="1p7k087yvua47">
                  {mode === 'create' ? 'Publish' : 'Save Changes'}
                </span>
                <span className="sm:hidden" data-id="element-20479" data-mp="1u1ehz5uxgf0n">
                  {mode === 'create' ? 'Publish' : 'Save'}
                </span>
              </>}
          </button>
        </div>}
    </div>;
};